export function getDashboardAppDestination(app, appSlugs = []) {
  if (
    app?.slug === 'fund-planner' &&
    !appSlugs.includes('fund-planner') &&
    appSlugs.includes('debt-studio')
  ) {
    return '/fund-planner/structurer';
  }

  return app?.to || '/dashboard';
}
